const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmazonpay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.335 20.026 c -2.405 0 -4.929 1.116 -6.889 2.856 l -0.22 -1.493 c -0.056 -0.376 -0.357 -0.694 -0.797 -0.694 h -2.093 c -0.383 0 -0.695 0.313 -0.695 0.694 c 0 9.498 0 18.997 0 28.495 c 0 0.382 0.313 0.694 0.695 0.694 h 2.735 c 0.382 0 0.694 -0.313 0.694 -0.694 v -9.84 c 1.735 1.547 3.991 2.437 6.403 2.437 c 5.73 0 9.118 -4.961 9.118 -11.135 C 33.286 25.576 31.071 20.026 24.335 20.026 z M 27.072 37.69 c -1.066 1.051 -2.256 1.337 -4.048 1.337 c -1.595 0 -3.693 -0.832 -5.26 -1.99 V 25.374 c 1.632 -1.253 3.713 -1.931 5.448 -1.931 c 4.53 0 5.764 3.562 5.764 7.641 C 29.002 33.834 28.496 36.286 27.072 37.69 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(51,62,71)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.316 41.267 c 0 0.382 -0.313 0.694 -0.697 0.694 h -2.042 c -0.441 0 -0.742 -0.319 -0.799 -0.694 l -0.205 -1.39 c -0.938 0.794 -2.09 1.492 -3.339 1.978 c -2.401 0.933 -5.17 1.087 -7.516 -0.354 c -1.697 -1.041 -2.597 -3.077 -2.597 -5.178 c 0 -1.625 0.501 -3.236 1.611 -4.405 c 1.481 -1.598 3.629 -2.383 6.221 -2.383 c 1.566 0 3.807 0.184 5.438 0.717 v -2.797 c 0 -2.844 -1.197 -4.074 -4.354 -4.074 c -2.413 0 -4.259 0.364 -6.827 1.163 c -0.411 0.014 -0.652 -0.299 -0.652 -0.681 v -1.595 c 0 -0.383 0.327 -0.753 0.681 -0.865 c 1.834 -0.8 4.433 -1.298 7.195 -1.39 c 3.601 0 7.881 0.812 7.881 6.351 V 41.267 z M 49.392 37.183 v -4.22 c -1.37 -0.375 -3.638 -0.53 -4.515 -0.53 c -1.386 0 -2.904 0.328 -3.697 1.181 c -0.592 0.626 -0.86 1.524 -0.86 2.392 c 0 1.123 0.388 2.249 1.296 2.806 c 1.054 0.716 2.689 0.629 4.225 0.192 C 47.317 38.586 48.704 37.844 49.392 37.183 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(51,62,71)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.179 49.847 c 0 -0.518 0 -0.983 0 -1.501 c 0 -0.427 0.21 -0.722 0.655 -0.695 c 0.832 0.118 2.008 0.236 2.844 0.064 c 1.091 -0.227 1.873 -1 2.336 -2.06 c 0.652 -1.492 1.084 -2.695 1.357 -3.484 l -8.282 -20.518 c -0.14 -0.348 -0.181 -0.994 0.514 -0.994 h 2.895 c 0.552 0 0.777 0.351 0.901 0.694 l 6.005 16.666 l 5.732 -16.666 c 0.117 -0.341 0.352 -0.694 0.899 -0.694 h 2.73 c 0.691 0 0.652 0.645 0.514 0.994 l -8.216 21.158 c -1.063 2.816 -2.479 7.302 -5.669 8.081 c -1.599 0.418 -3.617 0.267 -4.802 -0.229 C 57.293 50.513 57.179 50.112 57.179 49.847 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(51,62,71)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 84.123 48.992 c -2.8 0.039 -6.106 0.666 -8.614 2.426 c -0.774 0.537 -0.638 1.283 0.223 1.184 c 2.82 -0.339 9.097 -1.1 10.219 0.334 c 1.125 1.434 -1.244 7.35 -2.291 9.996 c -0.324 0.789 0.361 1.116 1.084 0.516 c 4.692 -3.93 5.911 -12.169 4.951 -13.354 C 89.214 49.501 86.923 48.953 84.123 48.992 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(247,156,52)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.647 51.992 c -0.654 0.09 -0.936 0.919 -0.252 1.576 c 11.751 11.022 27.28 16.419 44.521 16.419 c 12.297 0 26.574 -4.012 36.429 -11.573 c 1.629 -1.257 0.241 -3.141 -1.43 -2.397 c -11.049 4.875 -23.051 7.225 -33.974 7.225 c -16.189 0 -31.86 -3.38 -44.539 -11.057 C 1.126 52.017 0.865 51.962 0.647 51.992 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(247,156,52)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonpay);
export default __webpack_public_path__ + "static/media/amazonpay.759aa3714037b47f3b946e92e095cf3b.svg";
export { ForwardRef as ReactComponent };